<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card
            :loading="actionLoading"
        >
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="isEditable && showOnly">
                        Centrum dystrybucji - <strong>{{ distributionCenterData.name }}</strong>
                    </template>
                    <template v-else>
                        <template v-if="isNewDistributionCenter">
                            Dodaj centrum dystrybucji
                        </template>
                        <template v-else>
                            Edycja centrum dystrybucji- <strong>{{ distributionCenterData.name }}</strong>
                        </template>
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="distributionCenterModel.name"
                                :error-messages="distributionCenterNameErrors"
                                label="Nazwa centrum dystrybucji"
                                outlined
                                dense
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { isEmpty } from 'lodash'

export default {
    name: 'CampaignDistributionCenterDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        isEditable: {
            type: Boolean
        },
        distributionCenterData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            distributionCenterModel: {
                name: null,
                productSets: [],
            },
            actionLoading: false,
        }
    },
    validations() {
        let rules = {
            distributionCenterModel: {
                name: {
                    required,
                },
            },
        }

        return rules
    },
    computed: {
        isNewDistributionCenter() {
            return isEmpty(this.distributionCenterData)
        },
        distributionCenterNameErrors() {
            const errors = []

            if (!this.$v.distributionCenterModel.name.$dirty) return errors
            !this.$v.distributionCenterModel.name.required && errors.push('Proszę podać nazwę centrum dystrybucji.')

            return errors
        },
    },
    watch: {
        distributionCenterData(value) {
            if (!isEmpty(value)) {
                this.distributionCenterModel = {
                    name: value.name,
                    productSets: value.productSets,
                }
            } else {
                this.setInitialData()
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.$emit('on-save', this.distributionCenterModel)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.setInitialData()
                this.actionLoading = false
            }, 500)
            this.$emit('on-close')
        },
        setInitialData() {
            this.distributionCenterModel = {
                name: '',
                productSets: [],
            }
            this.$v.$reset()
        },
    }
}
</script>
